import { render } from "./ShoppingCartProductItem.vue?vue&type=template&id=23736bba&scoped=true"
import script from "./ShoppingCartProductItem.vue?vue&type=script&lang=js"
export * from "./ShoppingCartProductItem.vue?vue&type=script&lang=js"

import "./ShoppingCartProductItem.vue?vue&type=style&index=0&id=23736bba&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-23736bba"

export default script